import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { Info, Schedule } from '@mui/icons-material';
import { Alert, Box, Card, CardActions, CardContent, CardMedia, Chip, Grid, IconButton, Stack, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import * as GeoAdConstants from './GeoAdConstants.js';
import ETVPage from '../tools/ETVPage.js';
import ETVPopup from '../tools/ETVPopup.js';
import ETVMessagePopup from '../tools/ETVMessagePopup.js';
import ETVActionButton from '../tools/ETVActionButton.js';
import ApprovalOutlinedIcon from '@mui/icons-material/ApprovalOutlined';

class GeoAdApproval extends React.Component {

	constructor(props) {
      	super(props);
		this.closeInfoMessage = this.closeInfoMessage.bind(this);
    }

    state = {
      	isLoaded: false,
		isLoading: true,
		cur_booking:{},
		list:[],
		selected_media:'',
		selected_media_type:'',
		selected_media_filename:'',
		reject_booking_id:null,
		rejection_comment:'',
		window:'',
		spinning:false,
    }

    componentDidMount() {
		this.loadData();
    }

	componentDidUpdate() {
		if(this.state.isLoading) {
			return;
		}
		if(!this.state.isLoaded) {
			this.loadData();
		}
	}

	getGeoAdHeaders() {
		return {
			'user_id': localStorage.getItem("etv.user_id"),
			'access_token': localStorage.getItem("etv.access_token"),
		};
	}

    loadData() {
		this.setState({isLoading:true});
		fetch(GeoAdConstants.GEOAD_BACKEND+"?action=get_approvals",{ headers: this.getGeoAdHeaders() })
			.then(res => res.json())
			.then((result) => {
				if(result.result) {
					this.setState({
						list: this.filterPendingApprovals(result.approvals || []),
						isLoaded: true,
						isLoading:false,
					});
				}else{
					this.setState({
						isLoaded: true,
						isLoading:false,
					});
					this.showErrorMessage("Boostly approvals", result.error || "Could not load approvals.");
				}
			})
			.catch((error) => {
				this.setState({
					isLoaded: true,
					isLoading:false,
					error
				});
				this.showErrorMessage("Boostly approvals", error.message || "Could not load approvals.");
			});
    }

	sendApprovalAction(action, bookingID, approvalComment) {
		this.showInfoMessage("success","Boostly approvals", action==="approve_booking"?"Approving booking...":"Rejecting booking...",true);
		fetch(GeoAdConstants.GEOAD_BACKEND+"?action="+action,{
			method:'POST',
			headers:{...this.getGeoAdHeaders(),'Content-Type':'application/json'},
			body:JSON.stringify({booking_id:bookingID,approval_comment:approvalComment || ''}),
		})
			.then(res => res.json())
			.then((result) => {
				if(result.result) {
					this.setState({
						list: this.filterPendingApprovals(result.approvals || []),
						window:'',
						spinning:false,
					});
					this.showSuccessMessage("Boostly approvals", action==="approve_booking"?"Booking approved. Advertiser can now pay.":"Booking rejected.");
				}else{
					this.showErrorMessage("Boostly approvals", result.error || "Could not update booking.");
				}
			})
			.catch((error) => {
				this.showErrorMessage("Boostly approvals", error.message || "Could not update booking.");
			});
    }

	filterPendingApprovals(list) {
		return list.filter((item) => {
			var status = String(item.status || '').toUpperCase();
			return status==="SUBMITTED" || status==="PENDING_APPROVAL";
		});
	}

	showInfoMessage(infoType,title,msg,isSpinning) {
		this.setState({window:'message_div',info_type:infoType,info_title:title,info_message:msg,spinning:isSpinning});
	}

  	showSuccessMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'success',info_title:title,info_message:msg,spinning:false});
	}

	showErrorMessage(title,msg) {
	  	this.setState({window:'message_div',info_type:'error',info_title:title,info_message:msg,spinning:false});
	}

  	closeInfoMessage() {
	 	this.setState({window:'',info_type:'',info_title:'',info_message:undefined,spinning:false});
  	}

	getPreview(rowData) {
		var thumbnail = rowData.thumbnail_url || rowData.file_url;
		if(!thumbnail) {
			return <Box minHeight={240} display="flex" alignItems="center" justifyContent="center" bgcolor="grey.100" sx={{flex:'0 0 42%'}}>{rowData.media_type}</Box>;
		}
		if(rowData.media_type==="VIDEO") {
			return(
				<Box
					minHeight={240}
					display="flex"
					alignItems="center"
					justifyContent="center"
					bgcolor="grey.100"
					sx={{cursor:'pointer',flex:'0 0 42%'}}
					onClick={()=>this.showMedia(rowData)}
				>
					<Typography variant="body2">Video preview</Typography>
				</Box>
			);
		}
		return(
			<CardMedia
				component="img"
				image={thumbnail}
				alt={rowData.original_filename}
				sx={{width:{xs:'100%',sm:'42%'},minHeight:240,objectFit:'contain',bgcolor:'grey.50',cursor:'pointer'}}
				onClick={()=>this.showMedia(rowData)}
			/>
		);
	}

	getSubmitter(rowData) {
		return rowData.advertiser_email || rowData.advertiser_user_id || rowData.advertiser_contact || rowData.advertiser_company || 'Advertiser';
	}

	showMedia(rowData) {
		this.setState({
			selected_media:rowData.file_url,
			selected_media_type:rowData.media_type,
			selected_media_filename:rowData.original_filename,
			window:'show_media'
		});
	}

	approve(bookingID) {
		this.sendApprovalAction("approve_booking", bookingID);
	}

	reject(bookingID) {
		this.setState({window:'reject_dialog',reject_booking_id:bookingID,rejection_comment:''});
	}

	confirmReject() {
		this.sendApprovalAction("reject_booking", this.state.reject_booking_id, this.state.rejection_comment);
	}

	showBookingInfo(booking) {
		this.setState({cur_booking:booking,window:'booking_info_div'});
	}

	formatMoney(rowData) {
		return (rowData.currency || GeoAdConstants.GEOAD_CURRENCY)+" "+Number(rowData.total_amount || 0).toFixed(2);
	}

	getTrafficItems(rowData) {
		var summary = rowData.slot_summary || '';
		if(!summary) return [];
		return summary.split('|').map((item) => item.trim()).filter(Boolean).map((item) => {
			var parts = item.split(' ');
			return {
				date: parts[0] || '',
				level: parts[1] || '',
				time: parts.slice(2).join(' '),
			};
		});
	}

	getBookingDateRange(rowData) {
		var dates = [...new Set(this.getTrafficItems(rowData).map((item) => item.date).filter(Boolean))].sort();
		if(dates.length===0) return '';
		if(dates.length===1) return dates[0];
		return dates[0]+" until "+dates[dates.length-1];
	}

	trafficColor(level) {
		if(level==="MORNING_PEAK") return 'error';
		if(level==="LUNCH_PEAK") return 'warning';
		if(level==="DAYTIME_FLOW") return 'info';
		if(level==="EVENING_PEAK") return 'secondary';
		if(level==="OFF_PEAK") return 'success';
		return 'default';
	}

	trafficLabel(level) {
		if(level==="MORNING_PEAK") return 'Morning peak';
		if(level==="LUNCH_PEAK") return 'Lunch peak';
		if(level==="DAYTIME_FLOW") return 'Daytime flow';
		if(level==="EVENING_PEAK") return 'Evening peak';
		if(level==="OFF_PEAK") return 'Off-peak';
		return level || 'Traffic';
	}

	renderTrafficChips(rowData) {
		var levels = [...new Set(this.getTrafficItems(rowData).map((item) => item.level).filter(Boolean))];
		if(levels.length===0) {
			return <Chip size="small" icon={<Schedule />} label="Schedule pending" variant="outlined" />;
		}
		return levels.map((level) => (
			<Chip key={level} size="small" color={this.trafficColor(level)} label={this.trafficLabel(level)} variant="outlined" />
		));
	}

	renderApprovalCard(rowData) {
		return (
			<Card key={rowData.booking_id} variant="outlined" sx={{height:'100%',display:'flex',flexDirection:{xs:'column',sm:'row'},overflow:'hidden'}}>
				{this.getPreview(rowData)}
				<Box display="flex" flexDirection="column" flexGrow={1} minWidth={0}>
				<CardContent sx={{flexGrow:1}}>
					<Stack spacing={1.25}>
						<Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1}>
							<Box minWidth={0}>
								<Typography variant="subtitle1" fontWeight={700} noWrap title={rowData.original_filename || 'Creative'}>{rowData.original_filename || 'Creative'}</Typography>
								<Typography variant="body2" color="text.secondary" sx={{overflowWrap:'anywhere'}}>
									Submitted by {this.getSubmitter(rowData)}
								</Typography>
							</Box>
							<IconButton size="small" onClick={()=>{this.showBookingInfo(rowData)}}>
								<Info color="primary" />
							</IconButton>
						</Box>
						<Box display="flex" gap={0.75} flexWrap="wrap">
							{this.renderTrafficChips(rowData)}
						</Box>
						<Typography variant="body2">{rowData.location_name}</Typography>
						{this.getBookingDateRange(rowData) && (
							<Typography variant="body2" color="text.secondary">{this.getBookingDateRange(rowData)}</Typography>
						)}
					</Stack>
				</CardContent>
				<CardActions sx={{px:2,pb:2,pt:0}}>
					<Button fullWidth size="small" variant="contained" color="success" onClick={()=>{this.approve(rowData.booking_id)}}>Approve</Button>
					<Button fullWidth size="small" variant="outlined" color="error" onClick={()=>{this.reject(rowData.booking_id)}}>Reject</Button>
				</CardActions>
				</Box>
			</Card>
		);
	}

    render() {
		if(!this.state.list || this.state.list.length===0) {
			return (
				<ETVPage width="standard" icon={<ApprovalOutlinedIcon fontSize="large"/>} title="Boostly approvals" description="Review advertising creatives and approve or reject pending bookings." loading={this.state.isLoading}>
					{this.state.isLoaded && !this.state.isLoading && (
						<Alert severity="info">No Boostly bookings need approval.</Alert>
					)}
					<ETVMessagePopup type={this.state.spinning?'progress':this.state.info_type} allowClose={!this.state.spinning} open={this.state.window==='message_div'} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message}/>
				</ETVPage>
			);
		}

      	return(
			<ETVPage width="standard" icon={<ApprovalOutlinedIcon fontSize="large"/>} title="Boostly approvals" description="Review advertising creatives and approve or reject pending bookings." loading={this.state.isLoading}>
				<Grid container spacing={2}>
					{this.state.list.map((item) => (
						<Grid item xs={12} lg={6} key={item.booking_id}>
							{this.renderApprovalCard(item)}
						</Grid>
					))}
				</Grid>

				<ETVPopup
					open={this.state.window==='booking_info_div'}
					width="small" onClose={()=>this.setState({window:''})} icon={<Info/>} title="Booking information"
					description="Review the advertiser, building, schedule, creative, and booking amount."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.setState({window:''})}/> }>
						<Table>
							<TableBody>
								<TableRow>
									<TableCell>Advertiser</TableCell>
									<TableCell>{[this.state.cur_booking.advertiser_company, this.state.cur_booking.advertiser_contact, this.state.cur_booking.advertiser_email].filter(Boolean).join(' / ')}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Building</TableCell>
									<TableCell>{[this.state.cur_booking.location_name, this.state.cur_booking.address, this.state.cur_booking.city, this.state.cur_booking.country].filter(Boolean).join(', ')}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Creative</TableCell>
									<TableCell>{this.state.cur_booking.original_filename}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Duration</TableCell>
									<TableCell>{this.state.cur_booking.duration_sec}s</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Booking dates</TableCell>
									<TableCell>
										{this.getBookingDateRange(this.state.cur_booking)}
									</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>Amount</TableCell>
									<TableCell>{this.formatMoney(this.state.cur_booking)}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
				</ETVPopup>

				<ETVPopup
					open={this.state.window==='reject_dialog'}
					width="small" onClose={()=>this.setState({window:''})} icon={<ApprovalOutlinedIcon/>} title="Reject booking"
					description="Optionally explain to the advertiser why this booking was rejected."
					bottomActions={<><ETVActionButton action="cancel" onClick={()=>this.setState({window:''})}/><Button variant="contained" color="error" onClick={()=>this.confirmReject()}>Reject</Button></>}>
						<TextField
							fullWidth
							multiline
							minRows={3}
							margin="dense"
							label="Comment for advertiser"
							value={this.state.rejection_comment}
							onChange={(event)=>{this.setState({rejection_comment:event.target.value})}}
						/>
				</ETVPopup>

				<ETVMessagePopup type={this.state.spinning?'progress':this.state.info_type} allowClose={!this.state.spinning} open={this.state.window==='message_div'} onClose={this.closeInfoMessage} title={this.state.info_title} message={this.state.info_message}/>

				<ETVPopup
					open={this.state.window==='show_media'}
					width="wide" onClose={()=>this.setState({window:''})} icon={<ApprovalOutlinedIcon/>} title={this.state.selected_media_filename || 'Creative preview'}
					description="Preview the advertising creative before approving the booking."
					bottomActions={<ETVActionButton action="cancel" label="Close" onClick={()=>this.setState({window:''})}/> }>
						{this.state.selected_media_type==="VIDEO" ? (
							<video src={this.state.selected_media} controls style={{maxWidth:'100%',maxHeight:'75vh'}} />
						) : (
							<img src={this.state.selected_media} alt={this.state.selected_media_filename} style={{maxWidth:'100%',maxHeight:'75vh'}} />
						)}
				</ETVPopup>

			</ETVPage>);
	}
}

export default GeoAdApproval
